const updateFieldClasses = (field, container) => {
  if (field.value) {
    container.classList.add('-filled');
  } else {
    container.classList.remove('-filled');
  }
};

export const initInput = (field) => {
  const container = field.closest('[data-field]');

  updateFieldClasses(field, container);
  field.addEventListener('change', () => {
    updateFieldClasses(field, container);
  });
  field.addEventListener('focus', () => {
    container.classList.add('-active');
  });
  field.addEventListener('blur', () => {
    container.classList.remove('-active');
  });
};
